import React from "react";
import PropTypes from "prop-types";
import ConnectedGoalInput from "../../../ConnectedGoalInput";
import ConnectedTeamNameInput from "./ConnectedTeamNameInput";

const CreateTeamFields = ({
    teamFundraisingGoalDescription,
    teamFundraisingGoalHeading,
    teamNameHeading,
}) => (
    // eslint-disable-next-line tailwindcss/classnames-order
    <div className="grid grid--justify-content-center">
        <div className="col col--md-10 col--12 -text--center">
            <h3>{teamNameHeading}</h3>
        </div>
        <div className="col col--md-8 col--12 -text--center">
            <div className="-display--inline-block -width--80">
                <ConnectedTeamNameInput />
            </div>
        </div>
        <div className="col col--md-8 col--12 -text--center -margin-top--15">
            <h3>{teamFundraisingGoalHeading}</h3>
            <p>{teamFundraisingGoalDescription}</p>
        </div>
        <div className="col col--md-6 col--sm-8 col--10 -text--center -margin-bottom--30">
            <div className="-display--inline-block -width--80">
                <ConnectedGoalInput
                    id="New-Team-Fundraising-Goal"
                    name="New_Team_Fundraising_Goal"
                    allowsZeroDollarValue
                />
            </div>
        </div>
    </div>
);

CreateTeamFields.propTypes = {
    teamFundraisingGoalDescription: PropTypes.string.isRequired,
    teamFundraisingGoalHeading: PropTypes.string.isRequired,
    teamNameHeading: PropTypes.string.isRequired,
};

export default CreateTeamFields;
